'use client';

import { useIntl } from '@capsicum/common';
import { useMemo, useState } from 'react';

import { useVoucherQuery } from '../data-access/api';
import { PostVoucherErrorEnum, PostVoucherErrors } from '../models';

export const useRedeemVoucher = () => {
	const { $t } = useIntl();
	const [voucherCode, setVoucherCode] = useState<string>('');
	const { data: voucherData, error: voucherError, mutateAsync: mutateRedeemVoucher } = useVoucherQuery();

	const texts = useMemo(
		() => ({
			alreadyUsed: $t('wallet.voucher.error.alreadyUsed'),
			checkWallet: $t('wallet.voucher.checkWallet'),
			congratsRedeem: $t('wallet.voucher.congratsRedeem'),
			gotIt: $t('marketplace.gotIt'),
			placeholder: $t('wallet.voucher.voucherCode'),
			redeemVoucher: $t('wallet.voucher.redeemVoucher'),
			sociosTitle: $t('wallet.voucher.sociosTitle'),
			somethingWentWrong: $t('wallet.voucher.error.somethingWentWrong'),
			succesfullyRedeemed: $t('wallet.voucher.succesfullyRedeemed')
		}),
		[$t]
	);

	const handleErrorMessages = (errorCode: string) => {
		const error = PostVoucherErrorEnum[errorCode as keyof typeof PostVoucherErrorEnum];

		return error;
	};

	const getVoucherErrorMessage = (errorCode: null | string) => {
		switch (errorCode) {
			case PostVoucherErrors.ALREADY_USED:
				return texts.alreadyUsed;
			case PostVoucherErrors.HOLDING_LIMIT:
			case PostVoucherErrors.MINIMAL_LIMIT:
			case PostVoucherErrors.CUMULATIVE_LIMIT:
			case PostVoucherErrors.LIMIT_EXCEEDED:
			case PostVoucherErrors.FAILED:
				return texts.somethingWentWrong;
			default:
				return texts.somethingWentWrong;
		}
	};

	const errorCode = voucherError && handleErrorMessages(voucherError?.response?.data?.errors?.[0]?.code || '');
	const errorMessage = getVoucherErrorMessage(errorCode);

	return {
		errorMessage,
		getVoucherErrorMessage,
		mutateRedeemVoucher,
		setVoucherCode,
		texts,
		voucherCode,
		voucherData,
		voucherError
	};
};
